(function () {
  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function tick(timer) {
    var targetDate = new Date(timer.dataset.targetDate);

    if (isNaN(targetDate.getTime())) {
      return;
    }

    var msRemaining = targetDate.getTime() - Date.now();

    if (msRemaining <= 0) {
      timer.innerHTML = '';
      var expired = document.createElement('span');
      expired.className = 'drop-countdown__expired';
      expired.textContent = timer.dataset.expiredText || '';
      timer.appendChild(expired);
      return false;
    }

    var totalSeconds = Math.floor(msRemaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var days_el = timer.querySelector('[data-unit="days"]');
    var hours_el = timer.querySelector('[data-unit="hours"]');
    var minutes_el = timer.querySelector('[data-unit="minutes"]');
    var seconds_el = timer.querySelector('[data-unit="seconds"]');

    if (days_el) days_el.textContent = pad(days);
    if (hours_el) hours_el.textContent = pad(hours);
    if (minutes_el) minutes_el.textContent = pad(minutes);
    if (seconds_el) seconds_el.textContent = pad(seconds);

    return true;
  }

  function init() {
    var timers = document.querySelectorAll('.drop-countdown__timer[data-target-date]');

    timers.forEach(function (timer) {
      if (!tick(timer)) return;

      var intervalId = setInterval(function () {
        if (!tick(timer)) clearInterval(intervalId);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
